export const IMMEDIATE = "immediate";
export const FUTURE = "future";
export const PREBOOK = "prebook";
export type IDeliveryWindowType = "immediate" | "future" | "prebook";
export const DELIVERY_WINDOW_NONE = "none";
export const DELIVERY_WINDOW_SELECT_DATE = "select_date";
